export default /* glsl */`
  varying vec2 vUv;
  uniform sampler2D uTexture;

  void main(){
    vec3 pos = position.xyz;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(pos,1.);
    vUv = uv;
  }
`;
